"use strict";

var _classCallCheck = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/inherits");

var _regeneratorRuntime = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/regenerator");

var _this = this;

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var contract_wrappers_1 = require("@polymathnetwork/contract-wrappers");

var Procedure_1 = require("./Procedure");

var types_1 = require("../types");

var PolymathError_1 = require("../PolymathError");

var entities_1 = require("../entities");
/**
 * @hidden
 */


exports.createTransferSecurityTokensResolver = function (factories, symbol, from, to) {
  return function () {
    return __awaiter(_this, void 0, void 0,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee() {
      var refreshingFrom, refreshingTo;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              refreshingFrom = factories.tokenholderFactory.refresh(entities_1.Tokenholder.generateId({
                securityTokenId: entities_1.SecurityToken.generateId({
                  symbol: symbol
                }),
                address: from
              }));
              refreshingTo = factories.tokenholderFactory.refresh(entities_1.Tokenholder.generateId({
                securityTokenId: entities_1.SecurityToken.generateId({
                  symbol: symbol
                }),
                address: to
              }));
              return _context.abrupt("return", Promise.all([refreshingFrom, refreshingTo]));

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
  };
};
/**
 * Procedure that transfer security tokens
 */


var TransferSecurityTokens =
/*#__PURE__*/
function (_Procedure_1$Procedur) {
  _inherits(TransferSecurityTokens, _Procedure_1$Procedur);

  function TransferSecurityTokens() {
    var _this2;

    _classCallCheck(this, TransferSecurityTokens);

    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(TransferSecurityTokens).apply(this, arguments));
    _this2.type = types_1.ProcedureType.TransferSecurityTokens;
    return _this2;
  }
  /**
   * @hidden
   */


  _createClass(TransferSecurityTokens, [{
    key: "checkTransferStatus",
    value: function checkTransferStatus(statusCode, fromAddress, symbol, to, reasonCode, amount) {
      if (statusCode !== contract_wrappers_1.TransferStatusCode.TransferSuccess) {
        throw new PolymathError_1.PolymathError({
          code: types_1.ErrorCode.ProcedureValidationError,
          message: "Wallet \"".concat(fromAddress, "\" is not allowed to transfer ").concat(amount, " \"").concat(symbol, "\" tokens to \"").concat(to, "\". Possible reason: ").concat(reasonCode)
        });
      }
    }
    /**
     * Transfer security tokens from a wallet address to another
     * ***If from argument is not provided, the current SDK user address will be taken as it***
     *
     * Note that this procedure will fail if the security token symbol doesn't exist
     */

  }, {
    key: "prepareTransactions",
    value: function prepareTransactions() {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        var _this$args, symbol, to, amount, _this$args$data, data, from, _this$context, contractWrappers, currentWallet, factories, securityToken, fromAddress, _ref, statusCode, reasonCode, _ref2, _statusCode, _reasonCode;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this$args = this.args, symbol = _this$args.symbol, to = _this$args.to, amount = _this$args.amount, _this$args$data = _this$args.data, data = _this$args$data === void 0 ? '' : _this$args$data, from = _this$args.from;
                _this$context = this.context, contractWrappers = _this$context.contractWrappers, currentWallet = _this$context.currentWallet, factories = _this$context.factories;
                _context2.prev = 2;
                _context2.next = 5;
                return contractWrappers.tokenFactory.getSecurityTokenInstanceFromTicker(symbol);

              case 5:
                securityToken = _context2.sent;
                _context2.next = 11;
                break;

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2["catch"](2);
                throw new PolymathError_1.PolymathError({
                  code: types_1.ErrorCode.ProcedureValidationError,
                  message: "There is no Security Token with symbol ".concat(symbol)
                });

              case 11:
                _context2.next = 13;
                return currentWallet.address();

              case 13:
                fromAddress = _context2.sent;

                if (!(from && from !== fromAddress)) {
                  _context2.next = 23;
                  break;
                }

                _context2.next = 17;
                return securityToken.canTransferFrom({
                  to: to,
                  value: amount,
                  from: from
                });

              case 17:
                _ref = _context2.sent;
                statusCode = _ref.statusCode;
                reasonCode = _ref.reasonCode;
                this.checkTransferStatus(statusCode, from, symbol, to, reasonCode, amount);
                _context2.next = 29;
                break;

              case 23:
                _context2.next = 25;
                return securityToken.canTransfer({
                  to: to,
                  value: amount
                });

              case 25:
                _ref2 = _context2.sent;
                _statusCode = _ref2.statusCode;
                _reasonCode = _ref2.reasonCode;
                this.checkTransferStatus(_statusCode, fromAddress, symbol, to, _reasonCode, amount);

              case 29:
                _context2.next = 31;
                return this.addTransaction(securityToken.transferFromWithData, {
                  tag: types_1.PolyTransactionTag.TransferSecurityTokens,
                  resolvers: [exports.createTransferSecurityTokensResolver(factories, symbol, from || fromAddress, to)]
                })({
                  from: from || fromAddress,
                  to: to,
                  value: amount,
                  data: data
                });

              case 31:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[2, 8]]);
      }));
    }
  }]);

  return TransferSecurityTokens;
}(Procedure_1.Procedure);

exports.TransferSecurityTokens = TransferSecurityTokens;